<template>
  <div id="productos" class="py-5 bg-light">
    <div class="border-top mt-4 py-3">
      <titulo-seccion class="pb-2">¡Elige la mejor solución para tu empresa!</titulo-seccion>
      <p class="subtitulo m-0">Tenemos soluciones en todas las plataformas</p>
    </div>
    <div class="w-100 mx-auto mt-2 mt-lg-3">
      <b-tabs
        content-class=" mt-4"
        v-model="tabIndex"
        class="border-top pt-3 pt-lg-2"
        fill
        align="center"
      >
        <!-- -------------------- Todos ---------------------- -->
        <b-tab
          :title-link-class="linkClass(0)"
          title="Todos"
          class="text-dark"
          @click="definirCat('all')"
          active
        >
          <div class="row justify-content-center align-items-start bg-light">
            <div
              class="col-12 col-sm-6 col-lg-4"
              v-for="(item,index) in producto"
              @click="productoSeleccionado(item)"
              :key="index"
            >
              <div class="producto position-relative m-2">
                <img :src="item.imagenPortafolio || item.logo" class="img-fluid shadow" />
                <h1 class="pt-4 pb-3">{{item.descripcion}}</h1>
                <div
                  class="producto-info d-none"
                  :class="{'d-flex justify-content-center align-items-center' : selected === item }"
                >
                  <a
                    v-b-modal.my-modal2
                    @click="openModal(item, item.id)"
                    class="mx-2"
                    title="Vista previa"
                  >
                    <i class="fas fa-eye" style="font-size: 2.7em;"></i>
                  </a>
                  <router-link :to="'/'+item.path" class="mx-2" title="Ver Producto">
                    <i class="fas fa-info-circle" style="font-size: 2.7em;"></i>
                  </router-link>
                </div>
              </div>
            </div>
            <ModalProducto />
          </div>
        </b-tab>
        <!-- ------------------------------------------------- -->
        <!-- ------------------- Todos - Logos  ---------------------- -->
        <b-tab
          :title-link-class="linkClass(1)"
          title="Todos/Logos"
          class="text-dark"
          @click="definirCat('all')"
          active
        >
          <div class="row justify-content-center align-items-start bg-light">
            <div
              class="col-12 col-sm-6 col-lg-4"
              v-for="(item,index) in producto"
              @click="productoSeleccionado(item)"
              :key="index"
            >
              <div class="producto position-relative m-2">
                <img :src="item.logo" class="img-fluid w-75" />
                <h1 class="pt-4 pb-3">{{item.descripcion}}</h1>
                <div
                  class="producto-info d-none"
                  :class="{'d-flex justify-content-center align-items-center' : selected === item }"
                >
                  <a
                    v-b-modal.my-modal2
                    @click="openModal(item, item.id)"
                    class="mx-2"
                    title="Vista previa"
                  >
                    <i class="fas fa-eye" style="font-size: 2.7em;"></i>
                  </a>
                  <router-link :to="'/'+item.path" class="mx-2" title="Ver Producto">
                    <i class="fas fa-info-circle" style="font-size: 2.7em;"></i>
                  </router-link>
                </div>
              </div>
            </div>
            <ModalProducto />
          </div>
        </b-tab>
        <!-- ------------------------------------------------- -->
        <!-- -----------------------Web----------------------- -->
        <b-tab :title-link-class="linkClass(2)" title="Web" @click="definirCat('web')">
          <div class="row justify-content-center align-items-start bg-light">
            <div
              class="col-12 col-sm-6 col-lg-4"
              v-for="(item,index) in producto"
              @click="productoSeleccionado(item)"
              :key="index"
            >
              <div class="producto position-relative m-2">
                <img :src="item.imagenPortafolio || item.logo" class="img-fluid shadow" />
                <h1 class="pt-4 pb-3">{{item.descripcion}}</h1>
                <div
                  class="producto-info d-none"
                  :class="{'d-flex justify-content-center align-items-center' : selected === item }"
                >
                  <a
                    v-b-modal.my-modal2
                    @click="openModal(item, item.id)"
                    class="mx-2"
                    title="Vista previa"
                  >
                    <i class="fas fa-eye" style="font-size: 2.7em;"></i>
                  </a>
                  <router-link :to="'/'+item.path" class="mx-2" title="Ver Producto">
                    <i class="fas fa-info-circle" style="font-size: 2.7em;"></i>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- ----------------------Movil---------------------- -->
        <!-- ------------------------------------------------- -->
        <b-tab :title-link-class="linkClass(3)" title="Móvil" @click="definirCat('movil')">
          <div class="row justify-content-center align-items-start bg-light">
            <div
              class="col-12 col-sm-6 col-lg-4"
              v-for="(item,index) in producto"
              @click="productoSeleccionado(item)"
              :key="index"
            >
              <div class="producto position-relative m-2">
                <img :src="item.imagenPortafolio || item.logo" class="img-fluid shadow" />
                <h1 class="pt-4 pb-3">{{item.descripcion}}</h1>
                <div
                  class="producto-info d-none"
                  :class="{'d-flex justify-content-center align-items-center' : selected === item }"
                >
                  <a
                    v-b-modal.my-modal2
                    @click="openModal(item, item.id)"
                    class="mx-2"
                    title="Vista previa"
                  >
                    <i class="fas fa-eye" style="font-size: 2.7em;"></i>
                  </a>
                  <router-link :to="'/'+item.path" class="mx-2" title="Ver Producto">
                    <i class="fas fa-info-circle" style="font-size: 2.7em;"></i>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- -------------------Escritorio-------------------- -->
        <!-- ------------------------------------------------- -->
        <b-tab
          :title-link-class="linkClass(4)"
          title="Escritorio"
          @click="definirCat('escritorio')"
        >
          <div class="row justify-content-center align-items-start bg-light">
            <div
              class="col-12 col-sm-6 col-lg-4"
              v-for="(item,index) in producto"
              @click="productoSeleccionado(item)"
              :key="index"
            >
              <div class="producto position-relative m-2">
                <img :src="item.imagenPortafolio || item.logo" class="img-fluid shadow" />
                <h1 class="pt-4 pb-3">{{item.descripcion}}</h1>
                <div
                  class="producto-info d-none"
                  :class="{'d-flex justify-content-center align-items-center' : selected === item }"
                >
                  <a
                    v-b-modal.my-modal2
                    @click="openModal(item, item.id)"
                    class="mx-2"
                    title="Vista previa"
                  >
                    <i class="fas fa-eye" style="font-size: 2.7em;"></i>
                  </a>
                  <router-link :to="'/'+item.path" class="mx-2" title="Ver Producto">
                    <i class="fas fa-info-circle" style="font-size: 2.7em;"></i>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- ------------------------------------------------- -->
      </b-tabs>
    </div>
  </div>
</template>
<script>
import ModalProducto from "@/components/cliente/modals/ModalProducto.vue";
import { mapState } from "vuex";
export default {
  components: { ModalProducto },
  data() {
    return {
      categoria: "all",
      producto: [],
      tabIndex: 0,
      info: false,
      selected: null
    };
  },
  computed: {
    ...mapState(["Productos"])
  },
  methods: {
    productoSeleccionado(item) {
      if (this.selected == item) {
        this.selected = null;
      } else {
        this.selected = item;
      }
    },
    openModal(data, value) {
      this.$store.commit("setIndexProducto", value);
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ["bg-dark", "text-light", "h5"];
      } else {
        return ["bg-none", "text-secondary", "h5"];
      }
    },
    definirCat(valor) {
      this.producto = [];
      this.categoria = valor;
      if (this.categoria != "all") {
        this.Productos.forEach(element => {
          if (element.categoria == this.categoria) {
            this.producto.push(element);
          }
        });
      } else {
        this.producto = this.Productos;
      }
      return this.producto;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.producto = this.Productos;
  },
  created() {
    this.$store.state.colorHeader = true;
  },
  destroyed() {
    this.$store.state.colorHeader = false;
  }
};
</script>
<style scoped>
#productos {
  /* background: url("../../assets/backgroundsdm.png"); */
  min-height: 100vh;
  padding: 0 6%;
}
#productos h1 {
  margin: auto;
  max-width: 380px;
  font-size: calc(1.2em + 0.3vw);
}
.subtitulo {
  font-size: 1em;
  color: #595959;
  line-height: 1.4;
  font-size: calc(1.1em + 0.3vw);
}
#productos img {
  opacity: 1;
  object-fit: cover;
}
@media screen and (max-width: 480px) {
  #productos h1 {
    max-width: 340px;
  }
}
.producto {
  height: 100%;
  padding: 0px;
}
.producto:hover {
  cursor: pointer;
}
.producto-info {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  transition: all 0.3s;
  background: rgba(0, 156, 255, 0.72);
}
a {
  color: white;
}
a:hover {
  color: white;
  cursor: pointer;
}
</style>